{
  "login-page": {
    "buttons": {
      "next": "Tiếp theo",
      "sign-up": "Tạo tài khoản mới",
      "update-password": "Cập nhật mật khẩu",
      "use-phone-to-login": "Đăng nhập với số điện thoại",
      "use-email-to-login": "Đăng nhập với email"
    },
    "text": {
      "title": "Đăng nhập",
      "subtitle": "Đăng nhập vào Beauty Booking",
      "email": "Email của bạn",
      "or": "HOẶC",
      "password": "Mật khẩu",
      "password-hint": "Bạn cần cập nhật mật khẩu của mình",
      "username": "Tên tài khoản",
      "username-hint": "Bạn cần nhập email hoặc số điện thoại của mình"
    }
  }
}
